import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useCookie } from 'react-use';

export const useAuth = () => {
    const history = useHistory();
    const [isLoggedIn] = useCookie('isLoggedIn');
    useEffect(() => {
        if (!isLoggedIn) {
            history.push('/');
        }
    }, [isLoggedIn, history]);

    return isLoggedIn;
};
